import React from 'react';

export const InputError = ({
  error,
  id,
}: {
  error?: string;
  /** Do `aria-describedby` pól, które same nie są `<input>` — np. grupy radiowej. */
  id?: string;
}) => {
  if (!error) return null;
  return (
    <span
      id={id}
      data-form-error
      className="text-xs leading-[14px] text-error-200"
    >
      {error}
    </span>
  );
};

export default InputError;
